<script>
import { toRaw, toValue } from 'vue'
import JsBarcode from 'jsbarcode';
import { ref } from 'vue'
import { onMounted } from 'vue';

export default {
  props: {
    barcodeValue: String,
    index: Number,
    updateAll: Boolean
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    //edit later


  },
  created(){
    console.log(this.index)
  },
  updated() {
      JsBarcode(`#cv${this.index}`, this.barcodeValue, {
      format: "CODE128",
      // lineColor: "",
      width:1.5,
      height:30,
      fontSize:12,
      displayValue: true
      });

      console.log(this.updateAll)
  }

}
//Test barcode
//30058633
//97609353
//66677897

</script>

<template>

<div class="barcode-container">
    <img :id="`cv${this.index}`"></img>
    <button @click="$emit('close')">Hide</button>
     <!-- <svg id="barcode"></svg> -->
</div>

</template>

<style lang="scss" scoped>
    .barcode-container{
        // margin-bottom: 10em;
        // background-color: white;
        color: black;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: .75em;
    //   padding: 2em;
        font-weight: bold;
    }
</style>
